import TeambookSortingTypes from "../TeambookSortingTypes";
import PropTypes from "prop-types";

// eslint-disable-next-line no-unused-vars
const HeaderCell = ({ key, cell, dataOrder, setDataOrder, reversedDataOrder, setReversedDataOrder }) => {
  if (cell.value === "user_block") {
    return (
      <th key={key} style={cell.style} className="teambook-table__user-cell">
        <TeambookSortingTypes
          filterOrder={dataOrder}
          setFilterOrder={(field) => {
            setDataOrder(field);
            setReversedDataOrder(false);
          }}
          sortingTypes={["user"]}
        />
      </th>
    );
  }

  const filterClick = (field) => {
    if (!cell.sortingField) return;

    if (dataOrder === field) {
      setReversedDataOrder((prev) => !prev);
    } else {
      setDataOrder(field);
    }
  };

  return (
    <th
      key={key}
      colSpan={cell.colspan}
      style={{ ...cell.style, ...(cell.sortingField ? { cursor: "pointer" } : {}) }}
      className={cell.className}
      onClick={() => filterClick(cell.sortingField)}
    >
      {cell.value}
    </th>
  );
};

HeaderCell.propTypes = {
  key: PropTypes.string.isRequired,
  cell: PropTypes.shape({
    value: PropTypes.string,
    style: PropTypes.object,
    sortingField: PropTypes.string,
    colspan: PropTypes.number,
    className: PropTypes.string,
  }),
  dataOrder: PropTypes.string.isRequired,
  setDataOrder: PropTypes.func.isRequired,
  reversedDataOrder: PropTypes.bool.isRequired,
  setReversedDataOrder: PropTypes.func.isRequired,
};

export default HeaderCell;
